import { defineMessages } from 'react-intl';

export default defineMessages({ 
    startpagecancelChangeTitleGL:{
        // eslint-disable-next-line no-secrets/no-secrets
        "id":"CPMIpayrollreporting.requestchangeGL1.Cancel payroll reporting update",
        "defaultMessage":"Cancel payroll reporting update"
    },
    startpagecancelChangeMessageGL:{
        // eslint-disable-next-line no-secrets/no-secrets
        "id":"CPMIpayrollreporting.requestchangeGL1.Are you sure you want to cancel your payroll reporting changes?",
        "defaultMessage":"Are you sure you want to cancel your payroll reporting changes?"
    },
    // submitTitle:{
    //     "id":"CPMIpayrollreporting.requestchange.Certify Payroll",
    //     "defaultMessage":"Certify Payroll"
    // },
    draftErrorMessageGL:{
        "id":"CPMIpayrollreporting.requestchangeGL1.We are currently unable to access your data. Please contact us at 1.800.231.1363 so that we can assist.",
        "defaultMessage":"We are currently unable to access your data. Please contact us at 1.800.231.1363 so that we can assist."
    },
    compositeRateEndorsement:{
        "id":"CPMIStartPayrollGL.compositeRateEndorsement",
        "defaultMessage":"Composite Rate Endorsement"
    },
    compositeScheduleNumber:{
        "id":"CPMIStartPayrollGL.compositeScheduleNumber",
        "defaultMessage":"Schedule Number"
    },
    compositePremiumBasis:{
        "id":"CPMIStartPayrollGL.compositePremiumBasis",
        "defaultMessage":"Premium Basis"
    },
    compositeClass:{
        "id":"CPMIStartPayrollGL.compositeClass",
        "defaultMessage":"Class"
    },
    compositeExposure:{
        "id":"CPMIStartPayrollGL.compositeExposure",
        "defaultMessage":"Exposure"
    },
    compositeTotalExposure:{
        "id":"CPMIStartPayrollGL.compositeTotalExposure",
        "defaultMessage":"Total Exposure"
    },
});